import React from "react";
import SortByColor from "./Order/SortByColor";
import SortByGeometry from "./Order/SortByGeometry";
import SortByType from "./Order/SortByType";
import SortByText from "./Order/SortByText";

const miro = window.miro;

export default function OrderTools({
  boardSelection,
  userIsPro,
  environment,
}) {
  return (
    <div>
      <h3 className="h3 mt-0">Sort by...</h3>
      <SortByGeometry boardSelection={boardSelection} />
      <SortByColor boardSelection={boardSelection} />
      <SortByText boardSelection={boardSelection} />
      <SortByType boardSelection={boardSelection} />
    </div>
  );
}
